import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* getAlbum({params}) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_ALBUM, {params})
    );
    yield put(actionCreators.getAlbumSuccess({
      type: params.type,
      data: response.data
    }));
    
    if (response.ok) {
      const { data } = response.data.body;
     
    }
  } catch (error) {
    
  }
}

function* getAlbumDetail({params}) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_ALBUM + '/' + params.id)
    );
    yield put(actionCreators.getAlbumDetailSuccess({
      type: params.type,
      data: response.data
    }));
    
    if (response.ok) {
      const { data } = response.data.body;
     
    }
  } catch (error) {
    
  }
}

function* deleteAlbum({payload}) {
  try {
    const response = yield call(() =>
      API.post(ROUTES.API_DELETE_ALBUM+'/'+payload.id)
    );
    yield put(actionCreators.deleteAlbumSuccess({
      data: response
    }));
    yield put(actionCreators.resetAlbum())
  } catch (error) {
    
  }
}

function* album() {
  yield takeLatest(actionTypes.GET_ALBUM, getAlbum);
  yield takeLatest(actionTypes.GET_ALBUM_DETAIL, getAlbumDetail);
  yield takeLatest(actionTypes.DETETE_ALBUM_REQUEST, deleteAlbum);
}

export default album;
